export default __webpack_public_path__ + "atomic/_patterns/02-molecules/small-print-links/_small-print-links.twig";